(() => {
  const root = document.querySelector('[data-byob-inline]');
  if (!root) return;

  const CDN = root.dataset.cdnUrl;
  const IDS = { 2: root.dataset.bundle2, 3: root.dataset.bundle3 };
  const URLS = { 2: root.dataset.url2, 3: root.dataset.url3 };
  const DEFAULT_PACK = Number(root.dataset.defaultPack) || 2;
  // Kanonisk URL är byggarens egen sida (?pack=N) — aldrig produkt-URL:erna.
  // Produkt-URL:er i historik/bokmärken landar annars på den nakna bundle-PDP:n
  // utan pack-väljare vid hard refresh.
  const builderUrl = (pack) => window.location.pathname + '?pack=' + pack;
  const packFromUrl = () => {
    const p = Number(new URLSearchParams(window.location.search).get('pack'));
    return p === 2 || p === 3 ? p : null;
  };
  const container = root.querySelector('#bundling-app');
  const skeleton = root.querySelector('[data-byob-skeleton]');
  const fallback = root.querySelector('[data-byob-fallback]');
  const packLinks = [...root.querySelectorAll('[data-pack]')];

  let currentPack = null;
  let mounting = false;
  let remountCounter = 0;

  function setActivePill(pack) {
    packLinks.forEach((b) => {
      const on = Number(b.dataset.pack) === pack;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
    });
  }

  // Resolves true once the widget has rendered into the container, false on timeout.
  function waitForRender(timeoutMs) {
    return new Promise((resolve) => {
      if (container.children.length > 0) return resolve(true);
      const start = Date.now();
      const obs = new MutationObserver(() => {
        if (container.children.length > 0) { obs.disconnect(); resolve(true); }
      });
      obs.observe(container, { childList: true, subtree: true });
      const tick = setInterval(() => {
        if (container.children.length > 0) { clearInterval(tick); obs.disconnect(); resolve(true); }
        else if (Date.now() - start > timeoutMs) { clearInterval(tick); obs.disconnect(); resolve(false); }
      }, 200);
    });
  }

  // --- Bevara produktval över pack-byte (CRO 2026-07-09) ---
  // Läser valen ur gridens qty-inputs före re-mount och återspelar dem efteråt
  // via kortens egna kontroller (Lägg till-knapp + Öka-stepper) — samma väg som
  // användaren → widgetens interna state blir garanterat konsistent.
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  function readSelections() {
    const items = [];
    document.querySelectorAll('#recharge-bundles [role="gridcell"]').forEach((cell) => {
      const input = cell.querySelector('input[type="number"]');
      const title = cell.querySelector('.recharge-heading-h3');
      const qty = input ? parseInt(input.value, 10) || 0 : 0;
      if (qty > 0 && title) items.push({ title: title.textContent.trim(), qty });
    });
    return items;
  }

  async function waitForCells(timeoutMs) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (document.querySelector('#recharge-bundles [role="gridcell"] .recharge-heading-h3')) return true;
      await wait(150);
    }
    return false;
  }

  async function reapplySelections(items, need) {
    // 3→2-byte med 3 valda: återspela i grid-ordning tills nya paketet är fullt.
    // Returnerar titlarna som INTE fick plats (Lemme fas 3: tyst drop → synlig notis).
    let left = need;
    const dropped = [];
    for (const it of items) {
      const n = Math.min(it.qty, Math.max(left, 0));
      if (n < it.qty) dropped.push(it.title);
      if (left <= 0) continue;
      const cell = [...document.querySelectorAll('#recharge-bundles [role="gridcell"]')].find((c) => {
        const t = c.querySelector('.recharge-heading-h3');
        return t && t.textContent.trim() === it.title;
      });
      if (!cell) continue;
      for (let i = 0; i < n; i++) {
        // Första klicket = kortets "Lägg till"; därefter = Öka-steppern (i18n: Add/Increase pre-översättning).
        const add = [...cell.querySelectorAll('button')].find((b) => /lägg till|add/i.test(b.textContent) && !b.disabled);
        const inc = [...cell.querySelectorAll('span')].find((s) => /^(Öka|Increase)$/i.test((s.textContent || '').trim()));
        if (add) add.click();
        else if (inc) inc.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        else break;
        await wait(120); // låt React reconcilera mellan klicken
      }
      left -= n;
    }
    return dropped;
  }

  // Toast vid tyst drop (Lemme fas 3, 2026-07-09): 3 valda + byte till 2-pack
  // droppade tredje valet utan förklaring (CRO-audit). role="status" = uppläst.
  function noticeDropped(dropped, pack) {
    if (!dropped.length) return;
    document.querySelectorAll('.byob-drop-notice').forEach((n) => n.remove());
    const el = document.createElement('div');
    el.className = 'byob-drop-notice';
    el.setAttribute('role', 'status');
    el.textContent = dropped.join(' & ') + ' togs bort — ' + pack + '-packet rymmer ' + pack + ' gummies.';
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 6000);
  }

  // --- Bevara köpalternativ (engång vs prenumeration) över pack-byte (CRO runda 2,
  // 2026-07-09) --- Recharge nollställer frekvensen till prenumeration vid
  // om-montering. Läs valet före re-mount (frekvens-selecten: option value "0" =
  // engångsköp) och driv nya widgetens select till "0" via native setter +
  // input/change — samma mekanik som caene-byob-frequency-toggle (verifierad live
  // 2026-07-01). Frekvens-toggle-UI:t syncar sig självt från select-värdet via sin
  // observer, och kortpriserna följer med via caene-byob-card-prices.
  const SELECT_SETTER = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, 'value').set;

  function readOneTime() {
    const sels = document.querySelectorAll('#recharge-bundles select');
    for (const s of sels) {
      for (const o of s.options) { if (o.value === '0') return s.value === '0'; }
    }
    return false;
  }

  function driveOneTime() {
    document.querySelectorAll('#recharge-bundles select').forEach((s) => {
      if (![...s.options].some((o) => o.value === '0')) return;
      SELECT_SETTER.call(s, '0');
      s.dispatchEvent(new Event('input', { bubbles: true }));
      s.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // history: 'push' (pill click), 'replace' (initial load), 'none' (popstate — no history write)
  async function mount(pack, history) {
    if (mounting || pack === currentPack) return;
    mounting = true;
    // currentPack === null ⇒ initial mount (inget att bevara).
    const keep = currentPack ? readSelections() : [];
    const keepOneTime = currentPack ? readOneTime() : false;
    // Scroll-ankare (CRO runda 2, 2026-07-09): innerHTML='' krymper sidan ~2000px →
    // browsern klampar scrollY och användaren dumpas vid footern. Mät sektionens
    // viewport-position före tömningen och återställ direkt efter. null = initial
    // mount (rör aldrig scroll vid sidladdning).
    const anchorTop = currentPack ? root.getBoundingClientRect().top : null;
    fallback.hidden = true;
    setActivePill(pack);
    skeleton.style.display = '';
    container.innerHTML = '';
    if (anchorTop !== null) {
      const delta = root.getBoundingClientRect().top - anchorTop;
      if (delta) window.scrollBy(0, delta);
    }

    // Remove any previously-injected widget script so re-mounts don't accumulate.
    root.querySelectorAll('script[data-byob-widget]').forEach((s) => s.remove());

    window.StorefrontBundlingWidget = {
      containerId: 'bundling-app',
      externalProductId: Number(IDS[pack]),
      defaultLocale: undefined,
      translations: undefined,
    };

    // URL sync — reflect the active pack via ?pack=N on the builder page, no reload.
    if (history === 'push') window.history.pushState({ byobPack: pack }, '', builderUrl(pack));
    else if (history === 'replace') window.history.replaceState({ byobPack: pack }, '', builderUrl(pack));

    remountCounter += 1;
    const loaded = await new Promise((resolve) => {
      const s = document.createElement('script');
      s.dataset.byobWidget = '1';
      s.src = CDN + (CDN.indexOf('?') >= 0 ? '&' : '?') + 'remount=' + remountCounter;
      s.onload = () => resolve(true);
      s.onerror = () => resolve(false);
      root.appendChild(s);
    });

    const rendered = loaded ? await waitForRender(8000) : false;

    if (rendered && keep.length) {
      try {
        if (await waitForCells(6000)) {
          await wait(250);
          const dropped = await reapplySelections(keep, pack);
          noticeDropped(dropped, pack);
          // Frekvensen sist — selecten finns när summeringen renderats (även CSS-dold
          // i partial ligger den i DOM och är drivbar).
          if (keepOneTime) { await wait(300); driveOneTime(); }
        }
      } catch (e) { /* aldrig krascha widgeten */ }
    }

    skeleton.style.display = 'none';
    // Skyddsnät: var dokumentet för kort under skelettfasen klampades delta-
    // återställningen. Nu är sidan full höjd igen — gör om delta-återställningen
    // (no-op om första passet redan lyckades) och dra som sista utväg tillbaka
    // sektionen om den ändå ligger utanför viewporten.
    if (anchorTop !== null) {
      const delta2 = root.getBoundingClientRect().top - anchorTop;
      if (delta2) window.scrollBy(0, delta2);
      const r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) root.scrollIntoView({ block: 'start' });
    }
    // ?fallback=1 så bundle-PDP:ns redirect-till-byggaren inte studsar tillbaka hit.
    if (!rendered) { fallback.href = URLS[pack] + '?fallback=1'; fallback.hidden = false; }
    currentPack = pack;
    mounting = false;
  }

  // Pills are real <a> links to the product URLs; intercept for the soft-swap.
  packLinks.forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      mount(Number(b.dataset.pack), 'push');
    })
  );

  // Back/Forward between packs we pushed — re-mount without writing history.
  window.addEventListener('popstate', (e) => {
    const pack = e.state && e.state.byobPack ? Number(e.state.byobPack) : packFromUrl() || DEFAULT_PACK;
    mount(pack, 'none');
  });

  mount(packFromUrl() || DEFAULT_PACK, 'replace');
})();
